import React from 'react';
import { alertError, alertSuccess } from '../config/toast';
import {
  addSellerReq,
  updSellerReq,
  chSelPassReq,
  toggleSellerReq,
  togglePriorityReq,
  getSellersReq,
  getSellerPaymentsReq,
  rmSellerReq,
  getGlobalsReq,
  incCutReq,
  decCutReq,
} from '../config/httpRoutes';
import {
  Row,
  Form,
  Col,
  Card,
  Button,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowDown,
  faArrowUp,
  faChevronLeft,
  faEdit,
  faLock,
  faMoneyBill,
  faPlus,
  faRedo,
  faSearch,
  faSpinner,
  faTimes,
  faTrashAlt,
  faUndo,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import Loader from '../components/loader';
import TextInput from '../components/textInput';
import { connect } from 'react-redux';
import { getFormattedDate } from '../config/helpers';
import { commaRE } from '../config/regex';
import SelectInput from '../components/selectInput';

class Sellers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      phone: '',
      password: '',
      company: '',
      cutoff: '',
      type: '',
      defC: '',
      allSellers: null,
      sellers: null,
      key: '',
      errors: { name: '', phone: '', password: '', company: '' },
      loading: false,
      deleteLoading: false,
      fetchLoading: true,
      form: false,
      ch: false,
      id: '',
      payms: false,
    };
  }

  componentDidMount() {
    this.getSellers();
    this.getPreReqs();
  }

  getPreReqs = async () => {
    try {
      const { cutoff } = (await getGlobalsReq()).data;
      this.setState({
        cutoff,
        defC: cutoff,
      });
    } catch (err) {
      alertError('Could not fetch required data');
    }
  };

  getSellers = () => {
    this.setState({ fetchLoading: true });
    getSellersReq({ admin: this.props.match.params.id })
      .then((res) => {
        this.setState({
          allSellers: res.data,
          sellers: res.data,
          form: false,
          ch: false,
        });
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || 'Could not fetch sellers');
      })
      .finally(() => {
        this.setState({ fetchLoading: false });
      });
  };

  rmSeller = (id, index) => {
    this.setState({ deleteLoading: true });
    rmSellerReq({ id })
      .then((res) => {
        // const { sellers } = this.state;
        // sellers.splice(index, 1);
        // this.setState({sellers});
        this.getSellers();
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || 'Could not remove seller');
      })
      .finally(() => {
        this.setState({ deleteLoading: false });
      });
  };

  toggleSeller = (id, index) => {
    this.setState({ deleteLoading: true });
    toggleSellerReq({ id })
      .then((res) => {
        // const { sellers } = this.state;
        // sellers[index].disabled = !sellers[index].disabled;
        // this.setState({sellers});
        this.getSellers();
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || 'Could not update seller');
      })
      .finally(() => {
        this.setState({ deleteLoading: false });
      });
  };

  togglePriority = (id, index) => {
    this.setState({ deleteLoading: true });
    togglePriorityReq({ id })
      .then((res) => {
        // const { sellers } = this.state;
        // sellers[index].disabled = !sellers[index].disabled;
        // this.setState({sellers});
        this.getSellers();
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || 'Could not update seller');
      })
      .finally(() => {
        this.setState({ deleteLoading: false });
      });
  };

  handleChange = ({ target: { name, value } }) => {
    if (name === 'phone') {
      this.setState({
        [name]: (parseInt(value) || '').toString().slice(0, 10) || '',
      });
    } else {
      this.setState({ [name]: value });
    }
  };

  validate = () => {
    const { id, name, phone, password, company } = this.state;
    let errors = { name: '', phone: '', password: '', company: '' },
      isValid = true;

    if (!name) {
      errors.name = 'Enter name to continue';
      isValid = false;
    }
    if (!phone) {
      errors.phone = 'Enter phone to continue';
      isValid = false;
    }
    if (!company) {
      errors.company = 'Enter company name to continue';
      isValid = false;
    }
    if (!id && !password) {
      errors.password = 'Enter password to continue';
      isValid = false;
    }

    this.setState({ errors });
    return isValid;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { id, name, phone, password, company, cutoff , type} = this.state;
    const { id: admin } = this.props.match.params;
    if (this.validate()) {
      if (id) {
        this.setState({ loading: true });
        updSellerReq({ id, name, phone, admin, company, cutoff ,type})
          .then((res) => {
            this.setState({ loading: false });
            alertSuccess('Seller updated');
            this.getSellers();
          })
          .catch((err) => {
            this.setState({ loading: false });
            alertError(
              err?.response?.data?.msg ||
              err?.response?.data?.message ||
              'Could not complete request'
            );
          });
      } else {
        this.setState({ loading: true });
        addSellerReq({ name, phone, password, admin, company, cutoff,type })
          .then((res) => {
            this.setState({ loading: false });
            alertSuccess('Seller added');
            this.getSellers();
          })
          .catch((err) => {
            this.setState({ loading: false });
            alertError(
              err?.response?.data?.msg ||
              err?.response?.data?.message ||
              'Could not complete request'
            );
          });
      }
    }
  };

  navigateAdd = () => {
    this.setState({
      id: '',
      name: '',
      phone: '',
      password: '',
      company: '',
      cutoff: this.state.defC,
      errors: { name: '', phone: '', password: '', company: '' },
      loading: false,
      form: true,
    });
  };

  navigateEdit = (id, name, phone, /* password, */ company, cutoff) => {
    this.setState({
      id,
      name,
      phone,
      /* password, */ company,
      cutoff,
      errors: { name: '', phone: '', password: '', company: '' },
      loading: false,
      form: true,
    });
  };

  navigateCh = (id, name) => {
    this.setState({
      id,
      name,
      password: '',
      errors: { name: '', phone: '', password: '', seller: '' },
      ch: true,
      loading: false,
    });
  };

  navigateDeliverers = (id) => {
    this.props.history.push(`/deliverer/${id}`);
  };

  validate2 = () => {
    const { /* id, name, phone, */ password /* region */ } = this.state;
    let errors = { name: '', phone: '', password: '' },
      isValid = true;

    if (!password) {
      errors.password = 'Enter password to continue';
      isValid = false;
    }

    this.setState({ errors });
    return isValid;
  };

  submitCh = (e) => {
    e.preventDefault();
    const { id, password } = this.state;
    if (this.validate2()) {
      this.setState({ loading: true });
      chSelPassReq({ id, password })
        .then((res) => {
          this.setState({ loading: false });
          alertSuccess('Password changed');
          this.getSellers();
        })
        .catch((err) => {
          this.setState({ loading: false });
          alertError(
            err?.response?.data?.msg ||
            err?.response?.data?.message ||
            'Could not complete request'
          );
        });
    }
  };

  getSellerPayments = (seller) => {
    this.setState({ fetchLoading: true });
    getSellerPaymentsReq({ seller })
      .then((res) => {
        this.setState({ payms: res.data });
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || 'Could not fetch payments');
      })
      .finally(() => {
        this.setState({ fetchLoading: false });
      });
  };

  paymBack = () => {
    this.setState({ payms: false });
  };

  searchSells = (e) => {
    e.preventDefault();
    let { key } = this.state;
    if (!key) {
      return;
    }
    key = key.toLowerCase();
    const { allSellers } = this.state;
    const sellers = allSellers.filter(
      (s) => s.id.toString().toLowerCase().indexOf(key) > -1
      // || (s.phone.toLowerCase()).indexOf(key) > -1
    );
    this.setState({ sellers });
  };
  cancelSearch = () => {
    this.setState((st) => ({ sellers: st.allSellers, key: '' }));
  };

  incCuts = () => {
    this.setState({ deleteLoading: true });
    incCutReq()
      .then((res) => {
        this.getSellers();
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || 'Could not update cutoffs');
      })
      .finally(() => {
        this.setState({ deleteLoading: false });
      });
  };
  decCuts = () => {
    this.setState({ deleteLoading: true });
    decCutReq()
      .then((res) => {
        this.getSellers();
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || 'Could not update cutoffs');
      })
      .finally(() => {
        this.setState({ deleteLoading: false });
      });
  };

  render() {
    const {
      id,
      name,
      phone,
      password,
      company,
      cutoff,
      type,
      sellers,
      ch,
      deleteLoading,
      errors,
      loading,
      fetchLoading,
      form,
      payms,
      key,
    } = this.state;
    const {
      handleChange,
      handleSubmit,
      navigateAdd,
      navigateEdit,
      navigateCh,
      submitCh,
      rmSeller,
      toggleSeller,
      togglePriority,
      getSellerPayments,
      paymBack,
      navigateDeliverers,
      searchSells,
      cancelSearch,
      incCuts,
      decCuts,
    } = this;
    return ch ? (
      <Row style={{ marginLeft: 0, marginRight: 0 }}>
        <Col md={{ span: 4, offset: 4 }} lg={{ span: 4, offset: 4 }} xs={12}>
          <Card style={{ marginTop: '20%' }}>
            <Card.Header>
              <Card.Title style={{ textAlign: 'center' }}>
                Change Seller Password
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={submitCh}>
                <Form.Group>
                  <TextInput
                    onChange={handleChange}
                    value={password}
                    error={errors.password}
                    name="password"
                    label="Password"
                    type="password"
                  />
                </Form.Group>

                <Button
                  variant="success"
                  type="submit"
                  style={{ marginLeft: '30%', width: '40%', marginTop: '25px' }}
                  size="lg"
                  disabled={loading}
                >
                  {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Save'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    ) : form ? (
      <Row style={{ marginLeft: 0, marginRight: 0 }}>
        <Col md={{ span: 4, offset: 4 }} lg={{ span: 4, offset: 4 }} xs={12}>
          <Card style={{ marginTop: '20%' }}>
            <Card.Header>
              <Card.Title style={{ textAlign: 'center' }}>
                {id ? 'Update ' : 'Add '} Seller
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Form.Group>
                  <TextInput
                    onChange={handleChange}
                    value={name}
                    error={errors.name}
                    name="name"
                    label="Name"
                  />
                </Form.Group>
                <Form.Group>
                  <SelectInput onChange={handleChange} value={type} name="type" label="Type " options={['local', 'priority', 'independent']} />
                </Form.Group>
                <Form.Group>
                  <TextInput
                    onChange={handleChange}
                    value={phone}
                    error={errors.phone}
                    name="phone"
                    label="Phone Number"
                  />
                </Form.Group>

                <Form.Group>
                  <TextInput
                    onChange={handleChange}
                    value={company}
                    error={errors.company}
                    name="company"
                    label="Company Name"
                  />
                </Form.Group>

                <Form.Group>
                  <TextInput
                    onChange={handleChange}
                    value={cutoff}
                    error={errors.cutoff}
                    name="cutoff"
                    label="Cutoff %"
                  />
                </Form.Group>

                {id ? (
                  <></>
                ) : (
                  <Form.Group>
                    <TextInput
                      onChange={handleChange}
                      value={password}
                      error={errors.password}
                      name="password"
                      label="Password"
                      type="password"
                    />
                  </Form.Group>
                )}

                <Button
                  variant="success"
                  type="submit"
                  style={{ marginLeft: '30%', width: '40%', marginTop: '25px' }}
                  size="lg"
                  disabled={loading}
                >
                  {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Save'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    ) : payms ? (
      <Row
        style={{
          marginLeft: 0,
          marginRight: 0,
          paddingLeft: '10%',
          paddingRight: '10%',
          paddingTop: '5%',
          minHeight: '60vh',
        }}
      >
        <Col
          md={12}
          style={{
            justifyContent: 'space-between',
            display: 'flex',
            marginTop: '10px',
            marginBottom: '15px',
          }}
        >
          <div />
          <Button
            variant="success"
            onClick={paymBack}
            size="md"
            style={{ maxHeight: 40 }}
          >
            <FontAwesomeIcon icon={faChevronLeft} /> Back
          </Button>
        </Col>
        {fetchLoading && <Loader />}
        {Array.isArray(payms) ? (
          payms.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-hover table-attendance">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Date</th>
                    <th>Earning</th>
                    <th>Cutoff</th>
                    <th>Paid Amount</th>
                    <th>Paid on</th>
                  </tr>
                </thead>
                <tbody>
                  {payms.map(
                    (
                      { id, seller, earnings, paid, cutoff, date, paid_date },
                      i
                    ) => (
                      <tr key={i}>
                        <td>{id}</td>
                        <td>{getFormattedDate(parseInt(date))}</td>
                        <td>
                          ₹ {earnings?.toString().replace(commaRE, ',') || ''}
                        </td>
                        <td>{cutoff} %</td>
                        <td>
                          ₹ {paid?.toString().replace(commaRE, ',') || ''}
                        </td>
                        <td>{getFormattedDate(parseInt(paid_date))}</td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <p
              style={{ position: 'fixed', marginLeft: '34%', marginTop: '20%' }}
            >
              No payments found.
            </p>
          )
        ) : (
          <></>
        )}
      </Row>
    ) : (
      <Row
        style={{
          marginLeft: 0,
          marginRight: 0,
          paddingLeft: '10%',
          paddingRight: '10%',
          paddingTop: '5%',
          minHeight: '60vh',
        }}
      >
        <Col
          md={12}
          style={{
            justifyContent: 'space-between',
            display: 'flex',
            marginTop: '10px',
            marginBottom: '15px',
          }}
        >
          <div>
            <Form onSubmit={searchSells}>
              <Form.Group
                style={{
                  justifyContent: 'space-between',
                  display: 'flex',
                  width: '100%',
                }}
              >
                <TextInput
                  style={{ flex: 1 }}
                  onChange={handleChange}
                  value={key}
                  name="key"
                  label="Search Sellers"
                  icon={
                    key ? (
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={cancelSearch}
                        style={{ marginRight: 10, cursor: 'pointer' }}
                      />
                    ) : (
                      <></>
                    )
                  }
                />
                <Button
                  variant="success"
                  type="submit"
                  style={{ width: 40 }}
                  size="sm"
                  disabled={loading}
                >
                  {loading ? (
                    <FontAwesomeIcon icon={faSpinner} spin />
                  ) : (
                    <FontAwesomeIcon icon={faSearch} />
                  )}
                </Button>
              </Form.Group>
            </Form>
          </div>
          <div>
            <Button
              variant="success"
              onClick={incCuts}
              size="md"
              style={{ maxHeight: 40, marginRight: 20 }}
            >
              <FontAwesomeIcon icon={faArrowUp} /> Increase Cutoffs
            </Button>
            <Button
              variant="success"
              onClick={decCuts}
              size="md"
              style={{ maxHeight: 40, marginRight: 20 }}
            >
              <FontAwesomeIcon icon={faArrowDown} /> Decrease Cutoffs
            </Button>
            <Button
              variant="success"
              onClick={navigateAdd}
              size="md"
              style={{ maxHeight: 40 }}
            >
              <FontAwesomeIcon icon={faPlus} /> Add Seller
            </Button>
          </div>
        </Col>
        {fetchLoading && <Loader />}
        {Array.isArray(sellers) ? (
          sellers.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-hover table-attendance">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Company</th>
                    <th>Cutoff</th>
                    <th>Priority</th>
                    <th className="th1">Dependents</th>
                    <th className="th1">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {sellers.map(
                    (
                      {
                        id,
                        name,
                        phone,
                        company,
                        lat,
                        long,
                        open,
                        last_paid,
                        disabled,
                        total_sales,
                        total_paid,
                        cutoff,
                        prioritized,
                      },
                      i
                    ) => (
                      <tr key={i}>
                        <td>{id}</td>
                        <td>{name}</td>
                        <td>{phone}</td>
                        <td>{company}</td>
                        <td>{cutoff} %</td>
                        <td>{prioritized ? 'High' : 'Low'}</td>
                        <td className="text-center">
                          <div className="course-control-box icons-container d-flex">
                            <OverlayTrigger
                              overlay={<Tooltip>Deliverers</Tooltip>}
                              delay={{ show: 150, hide: 150 }}
                            >
                              <FontAwesomeIcon
                                icon={faUsers}
                                className="disabled-icon font-16 cursor-pointer mr-3"
                                onClick={(e) => {
                                  navigateDeliverers(id);
                                }}
                              />
                            </OverlayTrigger>
                            <OverlayTrigger
                              overlay={<Tooltip>Payments</Tooltip>}
                              delay={{ show: 150, hide: 150 }}
                            >
                              <FontAwesomeIcon
                                icon={faMoneyBill}
                                className="disabled-icon font-16 cursor-pointer"
                                onClick={(e) => {
                                  getSellerPayments(id);
                                }}
                              />
                            </OverlayTrigger>
                          </div>
                        </td>
                        <td className="text-center">
                          <div className="course-control-box icons-container d-flex">
                            <OverlayTrigger
                              overlay={<Tooltip>Edit</Tooltip>}
                              delay={{ show: 150, hide: 150 }}
                            >
                              <FontAwesomeIcon
                                icon={faEdit}
                                className="disabled-icon font-16 cursor-pointer mr-3"
                                onClick={(e) => {
                                  navigateEdit(
                                    id,
                                    name,
                                    phone,
                                    company,
                                    cutoff
                                  );
                                }}
                              />
                            </OverlayTrigger>
                            <OverlayTrigger
                              overlay={<Tooltip>Change Password</Tooltip>}
                              delay={{ show: 150, hide: 150 }}
                            >
                              <FontAwesomeIcon
                                icon={faLock}
                                className="disabled-icon font-16 cursor-pointer mr-3"
                                onClick={(e) => {
                                  navigateCh(id, name);
                                }}
                              />
                            </OverlayTrigger>
                            <OverlayTrigger
                              overlay={
                                <Tooltip>
                                  {disabled ? 'Enable' : 'Disable'}
                                </Tooltip>
                              }
                              delay={{ show: 150, hide: 150 }}
                            >
                              <FontAwesomeIcon
                                icon={disabled ? faRedo : faUndo}
                                className="disabled-icon font-16 cursor-pointer mr-3"
                                onClick={(e) => {
                                  toggleSeller(id, i);
                                }}
                              />
                            </OverlayTrigger>
                            <OverlayTrigger
                              overlay={
                                <Tooltip>
                                  {prioritized
                                    ? 'Change to Low priority'
                                    : 'Change to High priority'}
                                </Tooltip>
                              }
                              delay={{ show: 150, hide: 150 }}
                            >
                              <FontAwesomeIcon
                                icon={prioritized ? faArrowDown : faArrowUp}
                                className="disabled-icon font-16 cursor-pointer mr-3"
                                onClick={(e) => {
                                  togglePriority(id, i);
                                }}
                              />
                            </OverlayTrigger>
                            <OverlayTrigger
                              overlay={<Tooltip>Delete</Tooltip>}
                              delay={{ show: 150, hide: 150 }}
                            >
                              <FontAwesomeIcon
                                icon={faTrashAlt}
                                className="disabled-icon font-16 cursor-pointer"
                                onClick={(e) => {
                                  rmSeller(id, i);
                                }}
                              />
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <p
              style={{ position: 'fixed', marginLeft: '34%', marginTop: '20%' }}
            >
              No sellers found.
            </p>
          )
        ) : (
          <></>
        )}
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  userid: state.session.userid,
});

export default connect(mapStateToProps)(Sellers);
